import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { ArticleData } from "./ArticleData";
import { CategoryData } from "./CategoryData";
import { DetailArticle } from "./DetailArticle";

export const Information = (props) => {
  const [datafetch, datafetchSet] = useState({});

  useEffect(() => {
    async function fetchCategory() {
      let response = await fetch(
        process.env.REACT_APP_API_BEYEGROUP +"/categorie/" + process.env.REACT_APP_ID_INFOROMATION
      );
      response = await response.json();
      datafetchSet(response);
    }

    fetchCategory();
  }, []);

  const { t } = useTranslation();

  return (
    <section id="information" className="information">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2><span className="play-button"></span>{datafetch.icone} </h2>
          <p>{datafetch.description}</p>
        </div>

        <div className="row">
          <section id="blog" className="blog col-md-9">
            <div className="container" data-aos="fade-up">
              <div className="row gy-4 posts-list">
                <ArticleData
                    articles={
                      props.articles.filter(
                        (dat) => dat.id == props.articles[0]?.id
                      )
                    }
                    col = "mt-3 border_article col-11"
                  />
                {/* <div className="col-lg-12 mb-4 pb-4">
                  {
                    props.articles.length > 0 && (
                      <DetailArticle
                        article={props.articles[0]}
                        comment = ""
                        categories={props.categories.filter(
                          (cat) => cat.parentId == null
                        )}
                      />
                    )
                  }
                </div> */}

                <div>
                  {
                    
                    props.categories?.filter(va => va.parentId == process.env.REACT_APP_ID_INFOROMATION).map((val) =>(
                      <div style={{ paddingTop : props.articles.filter((dat) => dat.category?.id == val.id && props.articles.length > 0 && dat.id != props.articles[0].id )?.length> 0 ?  100 : 0, display : props.articles.filter((dat) => dat.category?.id == val.id && props.articles.length > 0 && dat.id != props.articles[0].id )?.length> 0 ? null : 'none' }} key={val.id} >
                     
                      <div style={{ margin : 20 }}>
                        <span style={{ backgroundColor : 'red', color : 'white', borderRadius : 10, fontWeight : '800', padding :10, fontWeight : 26 }}>
                          <i className={ val.icone } style={{ color : 'red'}}></i> { val.name}
                        </span>
                      </div>

                        <div className="row">
                          <ArticleData
                            col = "col-lg-6 col-md-6 mt-3"
                            articles={
                              props.articles
                                .filter(
                                  (dat) =>
                                    dat.category?.id == val.id &&
                                    props.articles.length > 0 &&
                                    dat.id != props.articles[0].id
                                )
                                .slice(0, 4)
                            }
                          />
                        </div>
                      </div>
                    ))
                  }
                </div>
                
              </div>
            </div>
          </section>

          <div className="col-lg-3 blog mt-4">
            <CategoryData
              articles={props.articleLast?.slice(0, 2)}
              categories={props.categories?.filter(va => va.id != process.env.REACT_APP_ID_DOCUMENTATION)}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
